<template>
  <div class="pl-3 pr-3 mb-5">
    <PageTitle title="Agente de IA Prompt Bel Energy" />

    <b-row class="mt-3" v-if="form.whatsapp">
      <b-col cols="3">
        <label>Quantos minutos seu agente vai ficar desativado?</label>
        <input
          type="number"
          class="form-control"
          v-model="form.reactivate_agent_date"
        />
      </b-col>

      <b-col cols="5">
        <label>Flag para ativar o Agente IA novamente</label>
        <input type="text" class="form-control" v-model="form.flag_message" />
      </b-col>

      <b-col cols="2" class="text-center">
        <label>Status</label>
        <input type="checkbox" class="form-control" v-model="form.status" />
      </b-col>

      <b-col cols="2" class="d-flex flex-column justify-content-end">
        <button class="btn btn-success btn-block" @click="saveContextAgentIa()">
          Salvar
        </button>
      </b-col>

      <b-col cols="12" class="mt-3">
        <JsonEditor
          v-model="form.prompt"
          mode="code"
          style="height: 600px; border: 1px solid #ccc; border-radius: 6px"
        />
      </b-col>

      <b-col cols="12" class="text-center">
        <button class="btn btn-success pl-4 pr-4 mt-3" @click="savePrompt()">
          Salvar Prompt
        </button>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col v-if="loading == false" cols="12">
        <h3>
          Primeiro você precisa conectar seu WhatsApp,
          <router-link :to="{ name: 'lojista-app-notificacoes-whatsapp' }"
            >clique aqui para conectar.</router-link
          >
        </h3>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PageTitle from 'Components/PageTitle.vue';
import JsonEditor from 'Components/Shopkeeper/JsonEditor.vue';
import makeToast from '@/mixins/makeToast';
import { mapState } from 'vuex';

export default {
  components: {
    PageTitle,
    JsonEditor,
  },

  mixins: [makeToast],

  data() {
    return {
      loading: false,
      form: {
        prompt: '',
        status: '',
        whatsapp: '',
        flag_message: '',
        reactivate_agent_date: '',
        construp_user_id: null,
      },
    };
  },

  computed: {
    ...mapState(['token', 'dadosUsuario']),
  },

  mounted() {
    this.getFormData();
  },

  methods: {
    getFormData() {
      this.loading = true;
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/getAgentIaPrompt', this.dadosUsuario.id)
        .then((res) => {
          if (res.data.whatsapp) {
            this.form = res.data;
            this.form.prompt = JSON.parse(this.form.prompt);
          }
        })
        .catch(() => {
          this.makeToast(
            'Erro!',
            'Ocorreu um erro, favor recarregar a página!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },

    savePrompt() {
      const payload = {
        prompt: JSON.stringify(this.form.prompt),
        construp_user_id: this.dadosUsuario.id,
      };

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/savePrompt', payload)
        .then(() => {
          this.makeToast(
            'Sucesso',
            'Prompt atualizado com sucesso!',
            'success'
          );
        })
        .catch(() => {
          this.makeToast(
            'Erro!',
            'Ocorreu um erro, favor recarregar a página!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },

    saveContextAgentIa() {
      const payload = {
        status: this.form.status,
        flag_message: this.form.flag_message,
        reactivate_agent_date: this.form.reactivate_agent_date,
        construp_user_id: this.dadosUsuario.id,
      };

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/saveContextAgentIaBelEnergy', payload)
        .then(() => {
          this.makeToast(
            'Sucesso',
            'Agente IA atualizado com sucesso!',
            'success'
          );
        })
        .catch(() => {
          this.makeToast(
            'Erro!',
            'Ocorreu um erro, favor recarregar a página!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
  },
};
</script>
